import { useCallback, useMemo } from "react";
import { isFunction } from "lodash";
import { useBuilderStore } from "@circle-react-shared/BuilderUI";
import type { SerializableComponentBlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { getBlockName } from "@circle-react-shared/BuilderUI/Helpers/getBlockName";
import { Preview } from "./Preview";

export interface ComponentPreviewProps {
  block: SerializableComponentBlockExport;
  isElementType?: boolean;
  isOverlay?: boolean;
}

export const ComponentPreview = ({
  block,
  isOverlay = false,
  isElementType = false,
}: ComponentPreviewProps) => {
  const { addBlocksToRoot, currentBlocks } = useBuilderStore(state => ({
    addBlocksToRoot: state.addBlocksToRoot,
    currentBlocks: state.getBlocks(),
  }));
  const defaultData = block.defaultData;
  const name = getBlockName({
    block: defaultData,
    meta: block.meta,
  });

  const isDisabled = useMemo(() => {
    if (isFunction(block.meta.isDisabled)) {
      return block.meta.isDisabled(currentBlocks);
    }
    return false;
  }, [block.meta, currentBlocks]);

  const handleAddBlock = useCallback(() => {
    if (isOverlay || isDisabled) return;
    addBlocksToRoot(defaultData, undefined, true);
  }, [addBlocksToRoot, defaultData, isOverlay, isDisabled]);

  return (
    <Preview
      isElementType={isElementType}
      name={name}
      block={block}
      onAddBlock={handleAddBlock}
      isOverlay={isOverlay}
      isDisabled={isDisabled}
    />
  );
};
